// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"902":"1256a61c","962":"5fba4827","4784":"471548f1","4978":"c1e658d9","7141":"d3e8e921","9096":"a2721b43"}[chunkId] + ".chunk.css";
};